import Tanamash from "./tanamas.webp";
import Zlivingh from "./zliving.webp";
import Levanteh from "./levante.webp";
import Vicenteh from "./vicente.webp";
import Grandlemonadeh from "./grandlemonade.webp";
import Gardenlofth from "./gardenloft.webp";
import O8h from "./o8.webp";
import Waterterraceh from "./waterterrace.webp";
import Thekaiah from "./kaia.webp";
import Cherryvilleh from "./cherryville.webp";
import Givah from "./giva.png";
import Altarah from "./altarahome.png";

const cardrumah = {
  Tanamash,
  Zlivingh,
  Levanteh,
  Vicenteh,
  Gardenlofth,
  Grandlemonadeh,
  Thekaiah,
  Waterterraceh,
  O8h,
  Cherryvilleh,
  Givah,
  Altarah,
};

export default cardrumah;
